import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const DataEngineering = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Data Engineering</h6>
          <hr />
          <h1 className="banner-title">
            Optimize Performance with Business <br /> Intelligence Solutions
          </h1>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>
        <img
          src="./assets/img/2003.png"
          alt="Banner Background"
          className="banner-image"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h6 className="col_yell">Data Engineering</h6>
              <h2>About Our Data Engineering Services</h2>
              <p>
                Our team specializes in building reliable, scalable, and secure
                data solutions. From designing data pipelines to integrating
                multiple data sources, we empower businesses to make data-driven
                decisions.
              </p>
              <ol>
                <li>Seamless Data Integration</li>
                <li>Optimized Storage Solutions</li>
                <li>Advanced Data Security</li>
                <li>Real-Time Processing</li>
              </ol>
            </div>
            <div className="col-md-6">
              <img
                src="./assets/img/2003.png"
                alt="Data Engineering"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services py-5 bg-black text-white">
        <div className="container">
          <h2 className="text-center mb-4">Our Services</h2>
          <div className="row">
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-database fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Data Pipelines</h5>
              <p>
                Efficient, scalable data collection and transformation
                pipelines.
              </p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-cloud-upload-alt fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Cloud Integration</h5>
              <p>
                Seamless data storage and integration on leading cloud
                platforms.
              </p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-tools fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Data Optimization</h5>
              <p>Optimized storage for cost-effective data management.</p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-lock fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Data Security</h5>
              <p>Advanced encryption and security protocols for your data.</p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-chart-bar fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Analytics Preparation</h5>
              <p>Prepare data for advanced analytics and AI-driven insights.</p>
            </div>
            <div className="col-md-4 text-center mb-4">
              <i
                className="fa fa-sync fa-3x text-primary mb-3"
                aria-hidden="true"
              ></i>
              <h5>Real-Time Processing</h5>
              <p>
                Enable real-time streaming and processing for instant insights.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section id="bi-cta" className="bi-cta text-center py-5">
    <h3>Ready to Transform Your Business with BI?</h3>
    <p>Contact us today to learn how Business Intelligence can unlock your company's potential.</p>
    <a href="#contact" className="btn btn-success mt-3">Get Started</a>
  </section> */}

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4  pt-5 pb-5 mx-0 px-4">
            <div className="col-md-8">
              <div className="serv_h3l">
                {/* <h6 className="">Benefits</h6> */}
                <h2 className="">Ready to Transform Your Data?</h2>
                <p className="mt-3">
                  Let’s discuss today to explore how we can help your business
                  harness the power of data engineering
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="./assets/img/2007.png"
                        className="w-100"
                        alt="Help"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataEngineering;
